{
  "familyId": "SWW-VT-STERK",
  "questions": [
    {
      "id": "SWW-VT-STERK-001",
      "familyId": "SWW-VT-STERK",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_sterk",
      "questionType": "multiple_choice",
      "question": "De kinderen ... gisteren in het zwembad. (zwemmen)",
      "context": null,
      "options": ["zwommen", "zwemden", "zwemmen", "gezwommen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": { "title": "Sterke Werkwoorden", "content": "Sterke werkwoorden veranderen van klank: zwemmen → zwom/zwommen. Ze krijgen GEEN -te of -de.", "icon": "lightbulb" },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "past_tense_strong_verb",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: sterke werkwoorden. Stap 1: 'Zwemmen' is een sterk werkwoord — de klinker verandert in de verleden tijd. Stap 2: De klinkerwisseling is e → o: zwemmen → zwom (enkelvoud) / zwommen (meervoud). Stap 3: 'De kinderen' is meervoud, dus: zwommen. Let op: sterke werkwoorden krijgen GEEN -te of -de.",
        "distractorExplanations": {
          "0": "Correct! 'Zwommen' is de juiste sterke verleden tijd meervoud. Klinkerwisseling: e → o.",
          "1": "Veelgemaakte fout: een sterk werkwoord vervoegen als zwak werkwoord. 'Zwemden' gebruikt -de (zwak), maar 'zwemmen' is sterk. Sterke werkwoorden veranderen van klank: zwemmen → zwommen (niet zwemden).",
          "2": "Veelgemaakte fout: tegenwoordige tijd gebruiken in plaats van verleden tijd. 'Zwemmen' is de tegenwoordige tijd. Het signaalwoord 'gisteren' vraagt om verleden tijd: zwommen.",
          "3": "Veelgemaakte fout: voltooid deelwoord gebruiken zonder hulpwerkwoord. 'Gezwommen' hoort bij 'hebben gezwommen'. Hier is geen hulpwerkwoord, dus gewoon verleden tijd: zwommen."
        }
      }
    }
  ]
}